import { useAppDispatch } from "../../app/hook";
import { useNavigate } from "react-router-dom";
import { showModal } from "../UI/modal/modal-slice";
import {
  Button,
  SpaceBetween,
  Box,
  ColumnLayout,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS, ApprovalStatusPattern } from "../default-constants";
import { PERMISSIONS } from "../../configs/constants";
import { useHasAuthorityHook } from "../../app/useHasAuthorityHook";

/*
 * ボタンの制御
 */
export const Buttons = (props: any) => {
  //権限取得
  const hasAuthority = useHasAuthorityHook(PERMISSIONS.MASTER_APPROVAL);
  const navigator = useNavigate();
  const dispatch = useAppDispatch();

  const returnToList = () => {
    if (!props.changeFlag) {
      navigator("/merchant-types");
    } else {
      dispatch(
        showModal({
          title: COMMON_LABELS.TITLES.DL,
          content: COMMON_LABELS.CONTENTS.PAGE_MOVE_CONFIRM,
          positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
          negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
          positiveFn: () => {
            navigator("/merchant-types");
          },
        })
      );
    }
  };

  const onClickTemporarilySaveBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.TEMPORARILY_SAVE,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickTemporarilySaveBtn();
        },
      })
    );
  };

  const onClickApprovalRequestBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.APPROVAL_REQUEST,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickApprovalRequestBtn();
        },
      })
    );
  };

  const onClickDeleteTemporarilySaveBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.DELETE_TEMPORARILY_SAVE,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickDeleteTemporarilySaveBtn();
        },
      })
    );
  };

  const onClickApprovalBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.APPROVAL,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickApprovalBtn();
        },
      })
    );
  };

  const onClickSendBackBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.SEND_BACK,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickSendBackBtn();
        },
      })
    );
  };

  const onClickApprovedPullBackBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.APPROVED_PULL_BACK,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickApprovedPullBackBtn();
        },
      })
    );
  };

  const onClickPullBackBtnHandler = () => {
    dispatch(
      showModal({
        title: COMMON_LABELS.TITLES.DL,
        content: COMMON_LABELS.CONTENTS.PULL_BACK,
        positiveBtn: COMMON_LABELS.POSITIVE_BUTTON.OK,
        negativeBtn: COMMON_LABELS.NEGATIVE_BUTTON.CANCEL,
        positiveFn: () => {
          props.onClickPullBackBtn();
        },
      })
    );
  };

  if (
    props.approvalStatus === ApprovalStatusPattern.beforeApproval.statusCode
  ) {
    // 承認前
    return (
      <ColumnLayout columns={2}>
        <Box float="left">
          <Button formAction="none" variant="link" onClick={returnToList}>
            {COMMON_LABELS.BTNS.BACK}
          </Button>
        </Box>
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xxl">
            <Button
              variant="normal"
              onClick={onClickDeleteTemporarilySaveBtnHandler}
            >
              {COMMON_LABELS.BTNS.DELETE_TEMPORARILY_SAVE}
            </Button>

            <Button variant="normal" onClick={onClickTemporarilySaveBtnHandler}>
              {COMMON_LABELS.BTNS.TEMPORARILY_SAVE}
            </Button>

            <Button
              variant="primary"
              onClick={onClickApprovalRequestBtnHandler}
            >
              {COMMON_LABELS.BTNS.APPROVAL_REQUEST}
            </Button>
          </SpaceBetween>
        </Box>
      </ColumnLayout>
    );
  } else if (
    props.approvalStatus === ApprovalStatusPattern.awaitingApproval.statusCode
  ) {
    // 承認待ち
    return (
      <ColumnLayout columns={2}>
        <Box float="left">
          <Button formAction="none" variant="link" onClick={returnToList}>
            {COMMON_LABELS.BTNS.BACK}
          </Button>
        </Box>
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xxl">
            {hasAuthority && (
              <Button variant="normal" onClick={onClickSendBackBtnHandler}>
                {COMMON_LABELS.BTNS.SEND_BACK}
              </Button>
            )}
            <Button variant="normal" onClick={onClickPullBackBtnHandler}>
              {COMMON_LABELS.BTNS.PULL_BACK}
            </Button>
            {hasAuthority && (
              <Button variant="primary" onClick={onClickApprovalBtnHandler}>
                {COMMON_LABELS.BTNS.APPROVAL}
              </Button>
            )}
          </SpaceBetween>
        </Box>
      </ColumnLayout>
    );
  } else if (
    props.approvalStatus === ApprovalStatusPattern.afterApproval.statusCode
  ) {
    // 承認済み
    return (
      <ColumnLayout columns={2}>
        <Box float="left">
          <Button formAction="none" variant="link" onClick={returnToList}>
            {COMMON_LABELS.BTNS.BACK}
          </Button>
        </Box>
        {hasAuthority && (
          <Box float="right">
            <Button
              variant="primary"
              onClick={onClickApprovedPullBackBtnHandler}
            >
              {COMMON_LABELS.BTNS.PULL_BACK}
            </Button>
          </Box>
        )}
      </ColumnLayout>
    );
  } else {
    // 初期登録&商用適用済み
    return (
      <ColumnLayout columns={2}>
        <Box float="left">
          <Button formAction="none" variant="link" onClick={returnToList}>
            {COMMON_LABELS.BTNS.BACK}
          </Button>
        </Box>
        <Box float="right">
          <Button variant="primary" onClick={onClickTemporarilySaveBtnHandler}>
            {COMMON_LABELS.BTNS.TEMPORARILY_SAVE}
          </Button>
        </Box>
      </ColumnLayout>
    );
  }
};
